module.exports = __webpack_public_path__ + "60756069bc1fb008389f5e8e65f308ac.png";


//////////////////
// WEBPACK FOOTER
// ../components/images/logo.png
// module id = 443
// module chunks = 0